import { render, staticRenderFns } from "./KeyWordsManager.vue?vue&type=template&id=19f153a4"
import script from "./KeyWordsManager.vue?vue&type=script&lang=js"
export * from "./KeyWordsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports